module.exports = __webpack_public_path__ + "static/media/c27.89509945.png";